import { Form, Input, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { getStaticCitis, getStaticProvinces } from "../../../../../service/api";
import { useQuery } from "@tanstack/react-query";
import ExpertDataContext from "../../../../../context/expertDataContext";

function InfoModal({ modalData }) {
  const { expertDataAction } = useContext(ExpertDataContext);
  const [provincesOptions, setProvincesOptions] = useState();
  const [citiesOptions, setCitiesOptions] = useState();

  const [provinceId, setProvinceId] = useState(modalData?.provinceId);
  //provinces
  const staticProvincesQuery = useQuery(
    ["staticsProvinces"],
    getStaticProvinces
  );
  //cities
  const staticCitiesQuery = useQuery(["staticCities"], getStaticCitis);

  useEffect(() => {
    if (staticProvincesQuery?.data) {
      let pOptions = staticProvincesQuery?.data?.map((province) => {
        return { label: province.name, value: province.id };
      });
      setProvincesOptions(pOptions);
    }
  }, [staticProvincesQuery?.data]);

  useEffect(() => {
    if (provinceId) {
      let cOptions = staticCitiesQuery?.data
        ?.filter((city) => city.province_id === provinceId)
        .map((c) => {
          return { label: c.name, value: c.id };
        });
      setCitiesOptions(cOptions);
    }
  }, [staticCitiesQuery?.data,provinceId]);

  const handleChange = (e) => {
    expertDataAction(e?.target?.name, e?.target?.value);
  };
  const handelSelectChange = (name, value) => {
    expertDataAction(name, value);
  };

  return (
    <Form layout="vertical">
      <Form.Item label="استان">
        <Select
          onChange={(value) => {
            setProvinceId(value);
            handelSelectChange("provinceId", value);
          }}
          options={provincesOptions}
          defaultValue={modalData?.province}
        />
      </Form.Item>
      <Form.Item label="شهر">
        <Select
          options={citiesOptions}
          defaultValue={modalData?.city}
          onChange={(value) => handelSelectChange("cityId", value)}
        />
      </Form.Item>
      <Form.Item label="کد نظام مهندسی">
        <Input
          name="engineeringSystemNumber"
          defaultValue={modalData?.engineeringSystemNumber}
          onChange={handleChange}
        />
      </Form.Item>
      <Form.Item label="رتبه و گرایش در نظام مهندسی">
        <Input
          name="engineeringSystemField"
          defaultValue={modalData?.engineeringSystemField}
          onChange={handleChange}
        />
      </Form.Item>
      
    </Form>
  );
}

export default InfoModal;
